import { all, takeEvery, call, select } from 'redux-saga/effects'

import { siteAbbreviationByAlias } from '../../../schema/mappers/site'

import { selectWebshopInOrder } from '../../selectors/webshop/webshop'
import { selectCartPackages } from '../../selectors/cart/cart'

import { ADD_PRODUCT_SUCCESS } from '../../actions/webshop/webshop'
import { PAYMENT_SUCCESS } from '../../actions/cart/cart'

import type { AddProductToBasketSuccessAction } from '../../actions/webshop/webshop'
import type { PaymentSuccessAction } from '../../actions/cart/cart'
import { TAX } from '../../../components/cart/Cart/Cart'
import { gtmPushEcommerceData } from '../../../util/google-tag-manager-pusher/GoogleTagManagerPusher'

export const CUSTOM_DIMENSIONS = {
  jobPosting: 'dimension18',
}

function* trackAddProduct({ payload }: AddProductToBasketSuccessAction) {
  const product = payload
  const data = {
    add: {
      products: [
        {
          name: product.name,
          id: product.productCode,
          price: product.price,
          quantity: 1,
        },
      ],
    },
  }

  if (product.jobPosting?.publishOn) {
    data.add.products[0][CUSTOM_DIMENSIONS.jobPosting] = product.jobPosting.publishOn
      .map(site => siteAbbreviationByAlias(site)?.toUpperCase())
      .join(' - ')
  }

  yield call(gtmPushEcommerceData, 'addToCart', data)
}

export function* trackConfirmOrder({ payload: { basketId, context, paymentMethod } }: PaymentSuccessAction) {
  const packages = yield select(context === 'webshop' ? selectWebshopInOrder : selectCartPackages)

  const products = packages.map(product => ({
    brand: [
      ...new Set([
        ...(((product.product?.jobPosting || product.jobPosting)?.publishOn) || []),
        ...(((product.product?.upgrades || product.upgrades || []).map(upgrade => upgrade.requiredSites)) || []),
      ]),
    ],
    id: product.product?.productCode || product.productCode,
    name: product.product?.name || product.name,
    price: product.price,
    quantity: product.amount || 1,
    tax: product.price * TAX,
    total: product.price * (1 + TAX),
  }))

  const data = {
    purchase: {
      actionField: {
        id: basketId,
        paymentMethod,
        dimension12: paymentMethod,
        revenue: packages.reduce((acc, { price }) => acc + price, 0),
        tax: packages.reduce((acc, { price }) => acc + price * TAX, 0),
        total: packages.reduce((acc, { price }) => acc + price * (1 + TAX), 0),
      },
      products,
    },
  }

  yield call(gtmPushEcommerceData, 'confirmOrder', data)
}

export default function* saga() {
  yield all([takeEvery(ADD_PRODUCT_SUCCESS, trackAddProduct), takeEvery(PAYMENT_SUCCESS, trackConfirmOrder)])
}
